import React, { useRef, useEffect } from "react";
import { Editor } from "@tinymce/tinymce-react";

export interface EmailHtmlEditorProps {
  value: string;
  onChange: (html: string) => void;
  styles?: React.CSSProperties;
}

const EmailHtmlEditor: React.FC<EmailHtmlEditorProps> = ({
  value = "",
  onChange,
  styles
}) => {
  const editorRef = useRef<any>(null);
  const isInitialMount = useRef(true);

  const apiKey = "4vfk4olxnhezuzq5mndbo1xq7whnjdkhqmbp1orpgbtn5pnv";

  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
      return;
    }

    const editor = editorRef.current;
    if (editor) {
      const current = editor.getContent({ format: "html" });
      if ((value || "").trim() !== (current || "").trim()) {
        editor.setContent(value || "");
      }
    }
  }, [value]);

  const filePickerCallback = (callback: any) => {
    const input = document.createElement("input");
    input.type = "file";
    input.accept = "image/*";

    input.onchange = () => {
      const file = input.files?.[0];
      if (!file) return;

      const reader = new FileReader();
      reader.onload = () => {
        callback(reader.result, { title: file.name });
      };
      reader.readAsDataURL(file);
    };

    input.click();
  };

  return (
    <div style={styles}>
      <Editor
        apiKey={apiKey}
        value={value}
        onInit={(_, editor) => {
          editorRef.current = editor;
          if (value) {
            editor.setContent(value);
          }
        }}
        onEditorChange={(content) => onChange(content)}
        init={{
          height: 400,
          menubar: false,
          branding: false,
          statusbar: false,
          resize: false,
          toolbar_mode: "wrap",

          plugins: [
            "link",
            "lists",
            "autoresize",
            "paste",
            "table",
            "autolink",
            "image",
            "fontfamily",
            "fontsize"
          ],

          toolbar:
            "undo redo | fontfamily fontsize | bold italic underline | forecolor backcolor | link image | bullist numlist outdent indent | alignleft aligncenter alignright",

          valid_elements: "*[*]",

          file_picker_types: "image",
          file_picker_callback: filePickerCallback,

          paste_data_images: true,
          images_file_types: "jpeg,jpg,png,gif,webp",

          convert_urls: false,
          relative_urls: false,
          remove_script_host: false,
          document_base_url: "",

          urlconverter_callback: (url: string) => {
            if (url.startsWith("data:")) {
              return url;
            }
            return url;
          },

          font_family_formats:
            "Arial=arial,helvetica,sans-serif; " +
            "Courier New=courier new,courier,monospace; " +
            "Helvetica=helvetica,arial,sans-serif; " +
            "Tahoma=tahoma,arial,helvetica,sans-serif; " +
            "Verdana=verdana,geneva,sans-serif",

          font_size_formats: "small=12px normal=14px large=20px huge=32px",
          font_size_default: "14px",

          content_style: `
            body {
              font-family: Arial, Helvetica, sans-serif;
              font-size: 14px;
              color: #333;
              padding: 10px;
              word-break: break-word;
            }
            p {
              margin: 0;
              font-size: 14px;
            }
            img, table {
              max-width: 100%;
              height: auto;
            }
          `,

          autoresize_bottom_margin: 20,

          mobile: {
            height: 300,
            menubar: false,
            toolbar:
              "undo redo | bold italic underline | link image | bullist numlist"
          }
        }}
      />
    </div>
  );
};

export default EmailHtmlEditor;
